/** Uso del lote; sin valor cuenta como CAMPO (igual que el backend y el dashboard). */
export type LoteUso = 'CAMPO' | 'ADMINISTRATIVO';

export const isCampoLote = (l: { uso?: LoteUso }): boolean => (l.uso ?? 'CAMPO') === 'CAMPO';

/** Deja solo los lotes de Campo (módulos operativos: drones, riego, aplicaciones, cosecha, cultivo, merma). */
export const onlyCampoLotes = <T extends { uso?: LoteUso }>(lotes: T[]): T[] => lotes.filter(isCampoLote);
